import {FloatingSignUp} from "components/commons";
import CalculatorInfoSection from "../CalculatorInfoSection";
import Calculator from "./Calculator";
import React from "react";

const SipSwpPageContent = () => (
  <>
    <Calculator />
    <FloatingSignUp />
    <CalculatorInfoSection slug="sip-swp" />
  </>
);

export default SipSwpPageContent;
